export default __webpack_public_path__ + "static/media/754.77def464.gif";